const { Component, render } = wp.element;

import { AA_2PerformantProductSync } from './sync.js';

document.addEventListener('DOMContentLoaded', function(event) {
  const syncElement = document.getElementById("AA_2Performant_sync");

  if( syncElement !=null ){
    render( <AA_2PerformantProductSync data={ syncElement.innerHTML } />, syncElement );
  }
})


// WEBPACK FOOTER //
// ./src/frontend.js